import { render, staticRenderFns } from "./UpdateModal.vue?vue&type=template&id=16e1d89f&scoped=true"
import script from "./UpdateModal.vue?vue&type=script&lang=js"
export * from "./UpdateModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateModal.vue?vue&type=style&index=0&id=16e1d89f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e1d89f",
  null
  
)

export default component.exports